import { render, staticRenderFns } from "./SubBanner.vue?vue&type=template&id=3bc6c1fb&scoped=true&"
import script from "./SubBanner.vue?vue&type=script&lang=js&"
export * from "./SubBanner.vue?vue&type=script&lang=js&"
import style0 from "./SubBanner.vue?vue&type=style&index=0&id=3bc6c1fb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc6c1fb",
  null
  
)

export default component.exports